import React, { useEffect } from 'react';
import { AuthProvider } from './contexts/AuthContext';
import { ChatProvider } from './contexts/ChatContext';
import InterviewApp from './components/InterviewApp';
import LanguageSelector from './components/LanguageSelector';
import { useTranslation } from 'react-i18next';
import './i18n';
import './App.css';

function App() {
  const { i18n } = useTranslation();

  // Set HTML direction and language attributes
  useEffect(() => {
    document.documentElement.lang = i18n.language;
    document.documentElement.dir = i18n.language === 'ar-SA' ? 'rtl' : 'ltr';
  }, [i18n.language]);

  return (
    <div className="App">
      <div className="language-selector-container">
        <LanguageSelector />
      </div>
      <AuthProvider>
        <ChatProvider>
          <InterviewApp />
        </ChatProvider>
      </AuthProvider>
    </div>
  );
}

export default App;